import { render, staticRenderFns } from "./DocRow.vue?vue&type=template&id=373fa0f8"
import script from "./DocRow.vue?vue&type=script&lang=ts"
export * from "./DocRow.vue?vue&type=script&lang=ts"
import style0 from "./DocRow.vue?vue&type=style&index=0&id=373fa0f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports